import React from 'react'
import Link from 'next/link'
import { TJournal } from '~shared/api/single-journal-data/types'
import { PATHS } from '~shared/constants/paths'
type TByThemeProps = {
  linkedJournal: Array<{
    id: number | null
    name: string | null
    journal: TJournal
  }>
}
export const JournalByTheme = ({ linkedJournal }: TByThemeProps) => {
  return (
    <div className='[&>a:not(:first-child)]:mt-[16px]'>
      <p className='text-[24px] font-medium'>По теме</p>
      <div className='border-b-[1.5px] border-[#3A52EE] mt-[8px] mb-[24px]' />
      {linkedJournal?.slice(0, linkedJournal.length / 2).map((journal, idx) => (
        <Link
          key={`LinkedJournal-Link__${idx + 1}`}
          href={`${PATHS.front.root.index}${PATHS.front.journal.ru}--${
            journal.journal?.tag?.slug
          }--${journal.journal?.slug}`}
          className='flex items-center text-[20px] text-accent  transition-colors duration-300 hover:underline underline-offset-4'>
          <span className='text-[20px]'>{journal.journal?.name}</span>
        </Link>
      ))}
    </div>
  )
}
